import { Button, Form, InputNumber } from 'antd';
import dayjs from 'dayjs';

const PredictionMatchCard = ({
  item,
  serverNow,
  isLoadingSubmit,
  getLeagueLogo,
  formatRemainingClock,
  onScorePredictClick
}) => {
  const isClosed = dayjs(item.countdown).isBefore(serverNow);
  const leagueLogo = getLeagueLogo ? getLeagueLogo(item.leagueName) : null;

  const allowNumberOnlyKey = (e) => {
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (allowedKeys.includes(e.key)) return;
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const allowNumberOnlyPaste = (e) => {
    const pasteData = e.clipboardData?.getData('text') || '';
    if (!/^\d+$/.test(pasteData)) {
      e.preventDefault();
    }
  };

  return (
    <div
      className={`flex w-full flex-col items-center gap-2 rounded-2xl border-[2px] border-solid border-[#006719] bg-[#F1F1F1] px-1 pb-2 text-sm font-medium shadow-[0_0_10.574px_0_rgba(0,0,0,0.09)_inset] ${
        isClosed ? 'contrast-50' : ''
      }`}
    >
      <div className="italic text-center min-w-[220px] rounded-b-[16px] bg-gradient-to-b from-[#016719] to-[#3DDB62] px-5 py-2 md:min-w-[300px] md:px-10">
        <p className="text-center text-xs font-bold leading-normal text-white not-italic sm:text-sm md:text-base lg:text-lg flex items-center justify-center gap-1">
          {leagueLogo ? (
            <img
              src={leagueLogo}
              alt={item.leagueName}
              className="w-4 h-4 object-contain rounded-full"
            />
          ) : null}
          {item?.leagueName}
        </p>
      </div>

      <div className="flex w-full flex-row items-center justify-center gap-1 pb-3 text-xs sm:text-sm md:gap-2 md:text-base">
        <div className="flex h-[44px] w-full items-center justify-center md:h-[50px] md:w-[330px]">
          <span className="flex h-full w-full flex-row items-center justify-center gap-[2px] px-[2px] py-[5px] text-[10px] sm:text-[12px] md:px-4 md:text-[14px]">
            <span
              className={`flex h-full items-center justify-center text-[10px] sm:text-[12px] md:text-[14px] ${
                isClosed ? 'text-red-500' : 'text-black'
              }`}
            >
              {isClosed ? 'Hết giờ' : 'Thời gian dự đoán còn: '}
            </span>
            {!isClosed ? (
              <span className="font-semibold text-[#016719]">
                {formatRemainingClock(item.countdown, serverNow)}
              </span>
            ) : null}
          </span>
        </div>

        <div className="flex h-[44px] w-full flex-row items-center justify-center md:h-[50px] md:w-[330px]">
          <span className="flex h-full w-full flex-row items-center justify-center gap-[2px] px-[2px] py-[5px] text-[10px] sm:text-[12px] md:px-4 md:text-[14px]">
            <span className="flex h-full items-center justify-center">Thời gian kết thúc: </span>
            <span className="ml-1 flex h-full items-center justify-center font-semibold text-[#016719]">
              {dayjs(item.startTime * 1000).format('HH:mm')}
            </span>
          </span>
        </div>
      </div>

      <div className="relative h-[70px] w-full xl:w-3/4 md:h-[90px]">
        <div
          className="absolute left-1/2 top-1/2 h-[60%] w-[95%] -translate-x-1/2 -translate-y-1/2 rounded-lg border-[2px] bg-[#016719] shadow-[inset_0_0_20px_0_#0C2E68]"
          style={{
            borderImageSource: 'linear-gradient(0deg, #AEC8F5 0%, #FFFFFF 100%)',
            borderImageSlice: 1
          }}
        />
        <div className="relative z-[1] grid h-full w-full grid-cols-[60px_minmax(0,1fr)_60px_minmax(0,1fr)_60px] items-center md:grid-cols-[90px_minmax(0,1fr)_90px_minmax(0,1fr)_90px]">
          <div
            className="flex h-[60px] w-[60px] items-center justify-center rounded-full bg-white p-[2px] shadow-[inset_0_0_5.43px_0_#00000040] md:h-[90px] md:w-[90px] md:p-[5px]"
            style={{ border: '1px solid #006719' }}
          >
            <img
              src={item.homeLogo}
              className="h-full w-[75%] object-contain"
              alt={item.homeName}
            />
          </div>

          <div className="min-w-0 px-1 text-center text-xs font-medium text-white sm:text-sm md:text-base">
            <span className="block whitespace-normal break-words leading-tight line-clamp-2">
              {item.homeName}
            </span>
          </div>

          <div className="flex items-center justify-center">
            <img
              src="/assets/images/match/vs.png"
              className="h-auto w-[90%] object-contain"
              alt=""
            />
          </div>

          <div className="min-w-0 px-1 text-center text-xs font-medium text-white sm:text-sm md:text-base">
            <span className="block whitespace-normal break-words leading-tight line-clamp-2">
              {item.awayName}
            </span>
          </div>

          <div
            className="flex h-[60px] w-[60px] items-center justify-center rounded-full bg-white p-[2px] shadow-[inset_0_0_5.43px_0_#00000040] md:h-[90px] md:w-[90px] md:p-[5px]"
            style={{ border: '1px solid #006719' }}
          >
            <img
              src={item.awayLogo}
              className="h-full w-[75%] object-contain"
              alt={item.awayName}
            />
          </div>
        </div>
      </div>

      <div className="flex w-full flex-col items-center justify-center px-2 sm:w-3/4">
        <div className="flex flex-row items-center justify-center gap-3 p-1 sm:gap-5 md:justify-around md:gap-16">
          <Form.Item className="m-0 p-0" name={`homeScore_${item.matchId}`}>
            <InputNumber
              disabled={isClosed}
              controls={false}
              min={0}
              max={99}
              maxLength={2}
              placeholder="Nhập số"
              onKeyDown={allowNumberOnlyKey}
              onPaste={allowNumberOnlyPaste}
              className="h-[34px] w-[70px] rounded-md border-0 bg-white text-center text-xs font-normal text-[#505050] shadow-[0px_1.057px_4.23px_0px_inset_rgba(0,0,0,0.29)] sm:h-[37px] sm:w-[90px] sm:text-sm md:h-[40px] md:w-[145px] md:text-base"
              style={{ textAlign: 'center', fontFamily: "'Roboto', sans-serif" }}
            />
          </Form.Item>
          <span className="whitespace-nowrap px-1 text-sm font-bold text-black sm:text-base md:text-lg">
            Tỉ số
          </span>
          <Form.Item className="m-0 p-0" name={`awayScore_${item.matchId}`}>
            <InputNumber
              disabled={isClosed}
              controls={false}
              min={0}
              max={99}
              maxLength={2}
              placeholder="Nhập số"
              onKeyDown={allowNumberOnlyKey}
              onPaste={allowNumberOnlyPaste}
              className="h-[34px] w-[70px] rounded-md border-0 bg-white text-center text-xs font-normal text-[#505050] shadow-[0px_1.057px_4.23px_0px_inset_rgba(0,0,0,0.29)] sm:h-[37px] sm:w-[90px] sm:text-sm md:h-[40px] md:w-[145px] md:text-base"
              style={{ textAlign: 'center', fontFamily: "'Roboto', sans-serif" }}
            />
          </Form.Item>
        </div>
      </div>

      {/* <div className="mt-2 flex w-full flex-row justify-center sm:w-3/4">
        <Button
          type="default"
          htmlType="submit"
          disabled={isClosed}
          loading={isLoadingSubmit}
          className="h-[38px] w-[140px] border-0 bg-transparent shadow-none transition-all duration-200 hover:scale-105 sm:h-[40px] sm:w-[163px] md:h-[44px]"
          style={{
            backgroundImage: 'url(assets/images/match/btn_send.png)',
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        />
      </div> */}
      <div className="mt-4 flex w-full justify-center">
        <div className="rounded-[10px] bg-gradient-to-b from-[#00ff88] to-[#006719] p-[2px] shadow-[0_4px_12px_rgba(0,0,0,0.2)]">
          <Button
            htmlType="submit"
            disabled={isClosed}
            loading={isLoadingSubmit}
            className={`
        !h-[42px] !min-w-[180px] md:!min-w-[220px]
        !rounded-[8px] !border-0 !shadow-none
        !bg-gradient-to-b !from-[#00CD32] !to-[#048724]
        !px-6
        !text-white !font-bold !text-[14px] md:!text-[18px]
        transition-all duration-200
        ${isClosed ? '!opacity-60 cursor-not-allowed' : 'hover:scale-105 active:scale-95'}
      `}
          >
            {isLoadingSubmit ? 'Đang gửi...' : 'Gửi dự đoán'}
          </Button>
        </div>
      </div>

      <div className="flex w-full flex-row items-center justify-center md:w-[330px]">
        <span className="flex h-full flex-row items-center justify-center gap-[3px] px-2 text-black">
          <span className="flex h-full items-center justify-center text-[14px] md:text-[16px]">
            Trước
          </span>
          <span className="ml-1 flex h-full items-center justify-center font-semibold text-[#016719]">
            {dayjs(item.startTime * 1000).format('HH:mm')}
          </span>
          <span className="flex h-full items-center justify-center text-[14px] md:text-[16px]">
            ngày
          </span>
          <span className="ml-1 flex h-full items-center justify-center font-semibold text-[#016719]">
            {dayjs(item.startTime * 1000).format('DD/MM/YYYY')}
          </span>
        </span>
      </div>
    </div>
  );
};

export default PredictionMatchCard;
